import React, { useState, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';

import { fetchFreeComicFlashDeals } from 'Redux/ducks/algolia-calls';
import ItemList from 'Components/Product/Seo/ItemList';
import ProductCarousel from '../HomePage/ProductCarousel';
import CountdownTimer from 'Components/Utility/CountdownTimer';
import imgixConfig from 'Config/imgix';

export default function FantasyVerseFreeComics() {
  const [hits, setHits] = useState([]);

  useEffect(() => {
    const doFetch = async () => {
      const newHits = await fetchFreeComicFlashDeals();
      setHits(newHits);
    };

    doFetch();
  }, []);

  const sliderSettings = {
    xs: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    sm: {
      slidesToShow: 2,
      slidesToScroll: 2,
    },
    md: {
      slidesToShow: 3,
      slidesToScroll: 3,
    },
    lg: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xl: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
    xxl: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  };

  if (isEmpty(hits)) return false;

  const dealLaunchDates = [
    '2025-05-02T10:00:00.000Z', // 11am UK
    '2025-05-03T08:00:00.000Z', // 9am UK
    '2025-05-05T08:00:00.000Z', // 9am UK
  ];

  let nextDealTime = '';
  cloneDeep(dealLaunchDates).reverse().forEach((time) => {
    if (Date.now() < Date.parse(time)) {
      nextDealTime = time;
    }
  });

  const lastLaunchTime = dealLaunchDates.sort()[dealLaunchDates.length - 1];
  const postlaunch = Date.now() > Date.parse(lastLaunchTime);

  // const sortedHits = hits;
  const sortedHits = hits.sort((a, b) => b.available_valid_from - a.available_valid_from);


  const bgImgSrc = 'https://cdn.fanatical.com/production/product/original/2e070664-c642-4a1e-a10d-5abcd324fbd7.jpeg';

  return (
    <section className="container FlashDealsSection">
      <div className="FlashDealsSection__headingBanner">
        <div className="FlashDealsSection__headingBanner__content">
          <div className="FlashDealsSection__headingBanner__content__headings">
            <h2 className="FlashDealsSection__headingBanner__content__headings__heading">
              <FormattedMessage
                id="fantasyverse-free-comics.heading.free-comic-book-day"
                defaultMessage="Free Comic Book Day"
              />
            </h2>
          </div>

          {!postlaunch &&
            <div className="FlashDealsSection__headingBanner__content__timer">
              <div className="FlashDealsSection__headingBanner__content__timer__text">
                <FormattedMessage id="fantasyverse-free-comics.heading.free-comic-book-day.timer" defaultMessage="Next Free Comic Drop" />
              </div>
              <div className="FlashDealsSection__headingBanner__content__timer__countdown">
                <CountdownTimer timerOverride showZero value={Date.parse(nextDealTime)} />
              </div>
            </div>
          }
        </div>
        <div className="FlashDealsSection__headingBanner__background">
          <img
            srcSet={`
              ${bgImgSrc}?${imgixConfig}&w=2248&h=200&fit=crop,
              ${bgImgSrc}?${imgixConfig}&w=1686&h=150&fit=crop,
              ${bgImgSrc}?${imgixConfig}&w=1124&h=100&fit=crop,
              ${bgImgSrc}?${imgixConfig}&w=562&h=50&fit=crop
            `}
            src={`${bgImgSrc}?${imgixConfig}&w=2248&h=200&fit=crop`}
            alt=""
          />
        </div>
      </div>

      <ItemList title="Free Comic Book Day" hits={sortedHits} />
      <ProductCarousel
        leftAlign
        showFakeCards
        showFlashDealBar
        hitData={sortedHits}
        carouselCoverSize="portrait"
        sliderSettings={sliderSettings}
      />
    </section>
  );
}
